<template>
    <v-row>
      <v-col cols="12">
        <v-card 
        class="mx-auto"
    >
    <v-container>
      <v-row>
        <v-col cols="12">
          <v-form
        class="m-5"
    ref="form"
    v-model="valid"
    lazy-validation
  >
    <v-text-field
      v-model="name"
      :counter="10"
      :rules="nameRules"
      label="Marca / Modelo"
      required
    ></v-text-field>

    <v-text-field
      v-model="enrollment"
      :counter="10"
      :rules="enrollmentRules"
      label="Placa / Serial"
      required
    ></v-text-field>
        
      
      <v-select
          :items="tipodeitem"
          label="Tipo de equipo"
          v-model="type"
        ></v-select>
         
         <v-autocomplete
            v-model="empresa"
            :items="empresas"
            outlined
            dense
            chips
            small-chips
            label="Empresa propietaria del equipo"
          ></v-autocomplete>


  <v-file-input accept="image/png, image/jpeg, image/bmp" v-model="images" label="Imagen del Equipo (opcional)"></v-file-input>

    

    <v-btn
      :disabled="!name||!empresa||!enrollment||!type||!tipodeitem"
      color="primary"
      class="mr-4"
      @click="subirVehi" 
      :loading="status"
    >
      Generar
    </v-btn>

    
  </v-form>
        </v-col>
      </v-row>
    </v-container>
        
    </v-card>
      </v-col>
      
      
    </v-row>
    

</template>
<script>

  import {SubirVehicle} from '../../../../../../services/team/vehicle'

  export default {
    
    mounted() {
      this.$store.dispatch('GetEmpresas')
    },
    
    data: () => ({
      valid: true,
      name: '',
      empresa:'',
      type:'',
      tipodeitem:['Vehiculo', 'Maquinaria'],  

      images:[],


      imagess:[],
      enrollment:'',
      status:false,
      disabled:false,
      
      itemss: ['foo', 'bar', 'fizz', 'buzz'],
      values: ['foo', 'bar'],
      value: null,

      nameRules: [
        v => !!v || 'Marca / Modelo es requerido',
        v => (v && v.length <= 20) || 'Name must be less than 10 characters',
      ],

       rulesImages: [
        value => value || value.size > 2000000 || 'Avatar size should be less than 2 MB!',
      ],

      enrollmentRules: [
        v => !!v || 'Placa \ Serial es requerido',
        v => (v && v.length <= 20) || 'La placa esta mal estructurada',
      ],

      email: '',
      emailRules: [
        v => !!v || 'E-mail is required',
        v => /.+@.+\..+/.test(v) || 'E-mail must be valid',
      ],
      select: null,
      items: [
        'Item 1',
        'Item 2',
        'Item 3',
        'Item 4',
      ],
      checkbox: false,
    
      item: 1,
      items: [
        { text: 'Real-Time', icon: 'mdi-clock' },
        { text: 'Audience', icon: 'mdi-account' },
        { text: 'Conversions', icon: 'mdi-flag' },
      ],
    
    
    }),

    

    watch: {
      images(item){
       return this.imagess.push(item)
      }
    },


    computed: {
      empresas(){
            
            var array = new Array

            for (let i = 0; i < this.$store.state.Enterprise.length; i++) {
                if (this.$store.state.Enterprise[i].Nombre != 'Sin asignacion') {
                  array.push(this.$store.state.Enterprise[i].Nombre)  
                }
                
            }
            
            return array;
        }
    },


    methods: {

      textoEmpresa:function(event){
        this.empresat = event
      },

      GetImg: function(event) {
            this.images = event.target.files;
      },

      subirVehi:function(){
        this.$store.dispatch('LoadingFetchActions', true);
        this.status = true
        this.disabled = true

        var data = new FormData();
        data.append('name', this.name);
        data.append('enrollment', this.enrollment);
        data.append('images',  this.images);
        data.append('empresa', this.empresa);
        data.append('type', this.type);
        
        SubirVehicle(data).then(response=>{
          
          console.log(response);
          this.status = false
          this.disabled = false
          this.$router.push({path: '/vehiculo'});
          this.$store.dispatch('GetVehicles');
          this.$store.dispatch('LoadingFetchActions', false);
          this.$toastr.success('Se ha agregado el vehìculo con exito');
        }).catch(errors=>{
          console.log(errors);
         this.status = false
          this.disabled = false
          this.$toastr.error(errors);
          this.$store.dispatch('LoadingFetchActions', false);
          
        })



      },

      validate () {
        if (this.$refs.form.validate()) {
          this.snackbar = true
        }
      },
      reset () {
        this.$refs.form.reset()
      },
      resetValidation () {
        this.$refs.form.resetValidation()
      },
    },
  }
</script>